import { useEffect, useState } from 'react';
import { fetchComment } from "../actions/mine_craft/commentsActions";
import { useAppDispatch } from "../store/hooks";
import { useSearchParams } from "react-router-dom";
import { queryParams } from "../helpers/UrlHelpers";
import { setPreloadReplies } from "../store/mine_craft/commentsSlice";

const useGoToComment = ({ limit = 2 }: { limit: number }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const goToComment                     = queryParams.getInt(searchParams,'go_to_comment');
  const [isRedirect, setIsRedirect]     = useState<boolean>(!!goToComment);
  const dispatch                        = useAppDispatch();

  useEffect(() => {
    if (goToComment) {
      findParentComment(goToComment);
    }
  }, [goToComment, dispatch, limit]);

  async function findParentComment(commentId: number)  {
    const result = await dispatch(fetchComment(commentId));

    if (fetchComment.fulfilled.match(result)) {
      const comment = Object.values(result.payload.comment)[0];

      if (comment.target_type === 'Comment') {
        dispatch(setPreloadReplies({ comment_id: comment.target_id, offset: comment.rank }))
        await findParentComment(comment.target_id);
      } else {
        const page = comment.rank ? Math.ceil(comment.rank / limit) : 1;
        searchParams.set('page', page.toString());
        done();
      }
    } else {
      done();
    }
  }

  const done = () => {
    setIsRedirect(false);

    searchParams.delete('go_to_comment');

    if (goToComment) {
      searchParams.set('comment_id', goToComment.toString());
    }

    setSearchParams(searchParams, { replace: true });
  }

  return isRedirect;
}

export default useGoToComment;
